import { Http } from '@angular/http';
import { BASE_URL } from './../config';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LinhaService {

  constructor(
    private http: Http
  ) { }

  getLinhas() {

    const url = `${BASE_URL}linhas.php`;

    return this.http.get(url)
    .pipe(
      map(
        res => res.json()
      )
    );
  }

  getLinhaById(id: number) {

    const url = `${BASE_URL}linha.php`;
    const obj = {linha: id};

    return this.http.post(url, obj)
    .pipe(
      map(
        res => res.json()
      )
    );
  }

  convertTrajeto(itinerario) {

    const list: any = {
      travelMode: 'WALKING',
      optimizeWaypoints: true,
      waypoints: []
    };

    const list_sec = itinerario.split(',');

    list.origin = list_sec[0] + ', Angra dos Reis';
    const last_points = list_sec.length - 1;
    list.destination = list_sec[last_points] + ', Angra dos Reis';

    list_sec.forEach((element, index) => {

      element = element.trim();

      list.waypoints.push({
        location: element + ', Angra dos Reis',
        stopover: true
      });

    });

    return list;

  }

}
